module.exports = __webpack_public_path__ + "static/media/arab14.7160dabc.wav";